import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function IncludesChecklist() {
  const items = ['Tomo 1 — Fundamentos de Aeronáutica y Atmósfera', 'Tomo 2 — Aerodinámica y Mecánica del Vuelo', 'Tomo 3 — Estructuras y Materiales Aeronáuticos', 'Tomo 4 — Planta Motriz, Motores y Propulsión', 'Bono 1 — Sistemas de a Bordo y Aviónica', 'Bono 2 — Operaciones de Vuelo y Meteorología', 'Bono 3 — Mantenimiento Aeronáutico y Aeronavegabilidad', 'Bono 4 — Proyecto Integrador y Aeronáutica del Futuro', 'Garantía de 7 días sin preguntas', 'Pago con tarjeta o Mercado Pago en pesos', 'Acceso inmediato tras la compra', 'Formato PDF listo para usar en el aula'];
  return <section className="py-12 bg-slate-950 border-y border-slate-800" data-id="element-144">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-145">
        <h3 className="text-2xl font-bold text-center mb-10 text-white" data-id="element-146">
          📦 TODO LO QUE INCLUYE:
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4" data-id="element-147">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.05
        }} className="flex items-start gap-3 p-3 rounded-lg hover:bg-slate-900/50 transition-colors" data-id="element-148">
              <CheckCircle2 className="w-5 h-5 text-slate-300 shrink-0 mt-0.5" data-id="element-149" />
              <span className="text-slate-200 font-medium text-[16px]" data-id="element-150">
                {item}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}